import styled from 'styled-components';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #fff;
    min-height: 100vh;

    @media (max-width: 800px) {
        height: 100%;
        min-height: 100%;
    }
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 460px;
    width: 100%;
    padding: 1rem 2rem 2.5rem 2rem;
    gap: 24px;
    flex-grow: 1;
`;

export const StyledTextarea = styled(Textarea)`
    width: 100%;
`;

export const StyledButton = styled(Button)`
    width: 100%;
    margin-top: 1rem;
`;

export const ButtonLabel = styled.span`
    width: 100%;
    padding-left: 1.4rem;
`;

export const TopContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
